// Device detection utility
const detectDevice = () => {
    const body = document.querySelector("body");
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    
    body.classList.remove("data-browser-cel", "data-browser-pc");
    body.classList.add(isMobile ? "data-browser-cel" : "data-browser-pc");
};

// URL utility functions
const isLandingPage = (mod) => {
    return window.location.pathname.includes(mod);
};

// Encryption utilities
const encrypt = (guide, pass) => {
    const salt = CryptoJS.lib.WordArray.random(256 / 8);
    const key = CryptoJS.PBKDF2(pass, salt, {
        keySize: 256 / 32,
        iterations: 1000
    });
    const iv = CryptoJS.lib.WordArray.random(128 / 8);
    const encrypted = CryptoJS.AES.encrypt(guide, key, {
        iv: iv,
        padding: CryptoJS.pad.Pkcs7,
        mode: CryptoJS.mode.CBC
    });
    return hexToBase64(salt + iv + base64ToHex(encrypted.toString()));
};

const hexToBase64 = (str) => {
    return btoa(String.fromCharCode.apply(null, 
        str.replace(/\r|\n/g, "")
           .replace(/([\da-fA-F]{2}) ?/g, "0x$1 ")
           .replace(/ +$/, "")
           .split(" ")
    ));
};

const base64ToHex = (str) => {
    const bin = atob(str.replace(/[ \r\n]+$/, ""));
    return Array.from(bin).map(char => {
        const hex = char.charCodeAt(0).toString(16);
        return hex.length === 1 ? "0" + hex : hex;
    }).join("");
};

// Shipping tracking functionality
const setupTrackingHandlers = () => {
    if (!isLandingPage('pages/rastrea-tu-guia')) return;

    // Envia tracking
    const setupEnviaTracking = () => {
        const getGuiaEnvia = document.querySelector('#getGuiaEnvia');
        const sendGuiaEnvia = document.querySelector('#sendGuiaEnvia');
        
        if (getGuiaEnvia) {
            getGuiaEnvia.addEventListener('keyup', (e) => {
                const guia = e.target.value;
                const newUrl = `https://envia.com/es-CO/rastreo?label==${guia}`;
                sendGuiaEnvia?.setAttribute('href', newUrl);
            });
        }
    };

    setupEnviaTracking();
};

// WhatsApp functionality
const setupWhatsAppButtons = () => {
    const insertarEnlaceWhatsApp = () => {
        const productos = document.querySelectorAll('.product-grid-item.product');
        
        productos.forEach((producto) => {
            if (producto.querySelector('.whatsapp-button')) return;
            
            const precio = producto.querySelector('.price');
            if (!precio) return;

            const enlaceWhatsApp = document.createElement('a');
            Object.assign(enlaceWhatsApp, {
                className: 'whatsapp-button',
                href: "https://api.whatsapp.com/send?phone=+573013474737&text=¡Hola! Me interesa este producto ",
                target: "_blank",
                rel: "noopener noreferrer",
                innerHTML: ' Lo Quiero!'
            });

            precio.insertAdjacentElement('afterend', enlaceWhatsApp);
        });
    };

    const setupCollectionLinks = () => {
        const enlaces = [
            ...document.querySelectorAll('.sidebar-inner a[href*="/collections/"]'),
            ...document.querySelectorAll('.basel-product-categories a[href*="/collections/"]')
        ];

        enlaces.forEach(enlace => {
            enlace.addEventListener('click', async (event) => {
                event.preventDefault();
                const url = enlace.getAttribute('href');
                
                try {
                    const response = await fetch(url);
                    const html = await response.text();
                    const doc = new DOMParser().parseFromString(html, 'text/html');
                    const nuevaColeccion = doc.querySelector('.site-content');

                    if (nuevaColeccion) {
                        document.querySelector('.site-content').innerHTML = nuevaColeccion.innerHTML;
                        insertarEnlaceWhatsApp();
                    }
                } catch (error) {
                    console.error('Error al cargar la nueva colección:', error);
                }
            });
        });
    };

    // Setup observer for dynamic content
    const targetNode = document.querySelector('.site-content');
    if (targetNode) {
        const observer = new MutationObserver(insertarEnlaceWhatsApp);
        observer.observe(targetNode, { childList: true, subtree: true });
    }

    insertarEnlaceWhatsApp();
    setupCollectionLinks();
};

function applyHeaderBlurFromBanner({
  bannerSelector = "body.template-index #MainContent img",
  headerSelector = "body.template-index .m-header__wrapper",
  alpha = 0.8,
  blur = "6px"
} = {}) {
  const bannerImage = document.querySelector(bannerSelector);
  const headerWrapper = document.querySelector(headerSelector);

  if (!bannerImage) {
    console.warn("[applyHeaderBlurFromBanner] Imagen no encontrada:", bannerSelector);
    return;
  }

  if (!headerWrapper) {
    console.warn("[applyHeaderBlurFromBanner] Header no encontrado:", headerSelector);
    return;
  }

  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  if (!ctx) {
    console.error("[applyHeaderBlurFromBanner] No se pudo obtener el contexto 2D del canvas.");
    return;
  }

  function updateHeaderBackground() {
    // Verificamos que la imagen esté visible (por si es un slider con display: none)
    const { naturalWidth, naturalHeight } = bannerImage;
    if (naturalWidth === 0 || naturalHeight === 0) {
      console.warn("[applyHeaderBlurFromBanner] Imagen sin dimensiones válidas.");
      return;
    }

    canvas.width = naturalWidth;
    canvas.height = 1;

    try {
      ctx.drawImage(bannerImage, 0, 0, naturalWidth, 1);
      const pixel = ctx.getImageData(0, 0, 1, 1).data;
      const rgba = `rgba(${pixel[0]}, ${pixel[1]}, ${pixel[2]}, ${alpha})`;

      headerWrapper.style.background = `linear-gradient(to bottom, ${rgba}, transparent)`;
      headerWrapper.style.backdropFilter = `blur(${blur})`;
      headerWrapper.style.webkitBackdropFilter = `blur(${blur})`;

      console.log("[applyHeaderBlurFromBanner] Color aplicado:", rgba);
    } catch (err) {
      console.error("[applyHeaderBlurFromBanner] Error al leer imagen con canvas:", err);
    }
  }

  if (bannerImage.complete) {
    updateHeaderBackground();
  } else {
    bannerImage.addEventListener("load", updateHeaderBackground);
  }
}




// Initialize everything when DOM is ready
document.addEventListener("DOMContentLoaded", () => {
    detectDevice();
    setupTrackingHandlers();
    setupWhatsAppButtons();
    applyHeaderBlurFromBanner();
});